var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildStylePropFn } from '../buildStyleFns';
import { borderColorFns, borderColorStyleFnConfigs } from './color';
import { borderLineStyleFns, borderLineStyleFnConfigs } from './lineStyle';
import { borderRadiusFns, borderRadiusStyleFnConfigs } from './radius';
import { borderShorthandFns, borderShorthandStyleFnConfigs, } from './shorthand';
import { borderWidthFns, borderWidthStyleFnConfigs } from './width';
/**
 * A style prop function that takes component props and returns border styles. Some props, such as borderRadius and borderColor, are connected to our design tokens.
 * If no `BorderStyleProps` are found, it returns an empty object.
 *
 * @example
 * ```tsx
 * const BorderExample = () => (
 *   <Box
 *    border="solid 1px"
 *    borderColor="soap500"
 *    borderRadius="l"
 *   >
 *     Hello, border styles!
 *   </Box>
 * );
 *```
 */
export var border = buildStylePropFn(__assign(__assign(__assign(__assign(__assign({}, borderColorFns), borderLineStyleFns), borderRadiusFns), borderShorthandFns), borderWidthFns));
export var borderStyleFnConfigs = __spreadArrays(borderColorStyleFnConfigs, borderLineStyleFnConfigs, borderRadiusStyleFnConfigs, borderShorthandStyleFnConfigs, borderWidthStyleFnConfigs);
